"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobile = exports.isiOS = void 0;
function isiOS() {
    // server side rendering
    if (typeof navigator === 'undefined')
        return false;
    return (/iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
}
exports.isiOS = isiOS;
function isMobile() {
    // server side rendering
    if (typeof navigator === 'undefined')
        return false;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
exports.isMobile = isMobile;
